import summary from 'reducers/dashboard/company/summary';
import { combineReducers } from 'redux';

export default combineReducers({
  summary,
});
